if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.atcWrapper = document.querySelector('.atc_wrapper');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      
      //Enavi restrict product
      this.productRestricted = this.hasAttribute("data-restricted-countries");
      this.hideButtons = false;
      if (this.productRestricted) {
        this.restrictProduct();
      }
      
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.hideButtons == true) return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if(this.productRestricted && this.hideButtons){
        return;
      }
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.innerHTML = errorMessage;
      }
    }

    //Enavi Custom JS for Product Blocker
    restrictProduct() {
      const productBlockerJson = document.querySelector('script[data-section-data="product-blocker"]');
      if (!productBlockerJson) {
        this.form.classList.remove('hidden');
        this.hideButtons = false;
        return;
      }

      const productBlockerData = JSON.parse(productBlockerJson.innerText);
      fetch(window.Shopify.routes.root + 'browsing_context_suggestions.json')
        .then(res => res.json())
        .then(r => {
          const clientLocation = r.detected_values.country.handle;
          for (const object of productBlockerData) {
            const blockedCountries = object.restricted_countries.split('|');
            const blockedMessage = object.restricted_message;
            if (blockedCountries.includes(clientLocation)) {
              this.handleErrorMessage(blockedMessage);
              this.submitButton.setAttribute('aria-disabled', true);
              this.error = true;
              this.hideButtons = true;
              this.form.classList.add('hidden');
              this.atcWrapper.classList.add('hidden');
              if(document.querySelector('.fulfilment-copy')){
                document.querySelector('.fulfilment-copy').classList.add('hidden');
              }
              return;
            }
          }
          this.form.classList.remove('hidden');
          this.hideButtons = false;
        });
    }

  });
}

//Enavi Custom Functions
window.theme = window.theme || {};

theme.EnaviProductForm = (function() {
  const selectors = {
    flavorDropdown: ".enavi-flavor_selector",
    qtyDropdown: "#pdp-qty-selector",
    qtyInput: "input.quantity__input",
    sizeLabel: ".form__label .label_selected",
  };
  
  function EnaviProductForm(container) {
    if(container && window.enaviFormInitialized != true){
      this.container = container;
      this.init();
    }
  };

  EnaviProductForm.prototype = Object.assign({}, EnaviProductForm.prototype, {
    init: function() {    
        window.enaviFormInitialized = true;
        this.flavorDropdown = this.select(selectors.flavorDropdown);
        this.qtyDropdown = this.select(selectors.qtyDropdown);
        this.qtyInput = this.select(selectors.qtyInput);
        this.addEventListeners();
    }, 

    select: function(selector){
      return this.container.querySelector(selector);
    },

    selectAll: function(selector){
      return Array.prototype.slice.apply(this.container.querySelectorAll(selector));
      },

    addEventListeners: function(){
      if (this.flavorDropdown) {
        this.flavorDropdown.addEventListener('change', this.getLinkedProduct.bind(this));
      }
      this.qtyDropdown.addEventListener('change', function(e){
        this.qtyInput.value = parseInt(e.target.value);
      }.bind(this)); 

      document.addEventListener('enavi:variant:change', this.updateOptionLabel.bind(this));
    },    

    getLinkedProduct: function(evt){
      var flavorEl = evt.target;
      var flavorContainer = flavorEl.closest('.flavor_selector_container');
      var productHandle = flavorEl.value;
      var productSection = flavorEl.closest('.shopify-section');
      var productSectionId = productSection.id.replace('shopify-section-','');
      var newProductId = parseInt(flavorEl.options[flavorEl.selectedIndex].dataset.productId);
      var selectedOptions = document.querySelectorAll('variant-radios > fieldset input[type="radio"]:checked');

      //Recharge Widget Selected Options
      var rechargeSubscriptionRadio = productSection.querySelector('.rc-radio__input:checked');
      var rechargeSellingPlan = productSection.querySelector('.rc_widget__option__plans__dropdown');
      var rechargeValue, rechargePlan = '';
      try {
        if(rechargeSubscriptionRadio){
          rechargeValue = rechargeSubscriptionRadio.value;
        }
        if(rechargeSellingPlan){
          rechargePlan = rechargeSellingPlan.options[rechargeSellingPlan.selectedIndex].dataset.planOption;
        }
      } catch (error) {
        console.log(error);
      }

      var newProductUrl = location.protocol + '//' + location.host + '/products/'+productHandle;
      fetch(newProductUrl+'?section_id='+productSectionId).then(
        res => res.text()).then((html) => { 
          let parser = new DOMParser();
          let doc = parser.parseFromString(html, "text/html");

          //Add flavor dropdown if doesn't exist
          if(!doc.querySelector('.flavor_selector_container')){
            doc.querySelector('variant-radios').parentNode.insertBefore(flavorContainer,doc.querySelector('variant-radios'))
          }

          productSection.innerHTML = doc.querySelector('.shopify-section').innerHTML;
          var newProductHandle = productSection.querySelector('product-info').dataset.url.replace('/products/','')
          var flavorSelector = productSection.querySelector('.enavi-flavor_selector');
          if(flavorSelector && flavorSelector.querySelector('option[selected]')){
            flavorSelector.querySelector('option[selected]').removeAttribute("selected");
          }
          if(flavorSelector && flavorSelector.querySelector('option[value="'+newProductHandle+'"]')){
            flavorSelector.querySelector('option[value="'+newProductHandle+'"]').setAttribute('selected','selected');
          }

          window.history.replaceState({}, document.title, newProductUrl);

          //Sync Variant Options
          selectedOptions.forEach(option => {
            if(option){
              var currentOption = productSection.querySelector('input[type="radio"][value="'+option.value+'"][name="'+option.name+'"]');
              if (currentOption) {
                currentOption.click()
              } 
            }
          });

          //Attach qty event listener
          var qtyDropdown =  productSection.querySelector('#pdp-qty-selector');
          var qtyInput =  productSection.querySelector('input.quantity__input');

          qtyDropdown.addEventListener('change', function(e){
            qtyInput.value = parseInt(e.target.value);
          }.bind(this)); 
          
          if(flavorSelector){
            flavorSelector.addEventListener('change', this.getLinkedProduct.bind(this)); 
          }

          //Reinitialize Recharge Widget
          if(window.ReChargeWidget){
            try {
              const rechargeConfig = {
                productId: parseInt(newProductId), // Required
                injectionParent: '.recharge-subscription-widget', // The node that will have the widget injected in
                injectionMethod: 'prepend',
                injectFn: (node, target) => {}
              };

              window.ReChargeWidget.destroyAllWidgets();
                window.ReChargeWidget.createWidget(rechargeConfig);
                setTimeout(() => {
                  if (rechargeValue !== '') {
                    const rechargeRadioInput = document.querySelector('.rc-radio__input[value="' + rechargeValue + '"]');
                    if (rechargeRadioInput) {
                      rechargeRadioInput.click();
                    }
                  }
            
                  if (rechargePlan !== '') {
                    const rechargePlanOption = document.querySelector('.rc_widget__option__plans__dropdown option[data-plan-option="' + rechargePlan + '"]');
                    if (rechargePlanOption) {
                      rechargePlanOption.selected = true;
                    }
                  }
                  executeSubscriptionLayoutScript(true);
                }, 1000);
            } catch (e) {
              console.log(e);
            }
          }
          
          //Sync review section
          var reviewSection = document.querySelector('#judgeme_product_reviews').closest('.shopify-section');
          if(reviewSection){
            var reviewSectionId = reviewSection.id.replace('shopify-section-','');
            fetch(newProductUrl+'?section_id='+reviewSectionId).then(
              res => res.text()).then((html) => { 
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, "text/html");
  
                reviewSection.innerHTML = doc.querySelector('.shopify-section').innerHTML;
                const jdgmScript = document.querySelector('script[src="https://cdn.judge.me/loader.js"]');
                if(jdgmScript){
                  jdgmScript.remove();
                }
                const jdgmLoader = document.createElement('script');
                jdgmLoader.src = 'https://cdn.judge.me/loader.js';
                document.head.appendChild(jdgmLoader);
            })
          }       
          
      })
    },
    updateOptionLabel: function(evt){
      if (evt.detail) {
        var sizeLabel = document.querySelector(selectors.sizeLabel);
        sizeLabel.innerText = evt.detail.variant.title;
      }
      //Update qty input on variant change 
      var qtyDropdown =  document.querySelector('#pdp-qty-selector');
      var qtyInput =  document.querySelector('input.quantity__input');
      
      qtyDropdown.value = qtyInput.value;
    }

  });

  return EnaviProductForm;
})(); 

  new theme.EnaviProductForm(document.querySelector('.product__info-wrapper'));
  /* ENAVI ADA Compliance */
    document.addEventListener("DOMContentLoaded", function (){
      setTimeout(function(){
      var selectBox = document.querySelectorAll('.bold_options select');
      for(var i=0;i<selectBox.length;i++){
        selectBox[i].setAttribute('aria-label','Please select '+selectBox[i].getAttribute('name').split('[')[1].replace(']',''));
      }
          },1000)
    })
  /* ENAVI ADA Compliance */